import { createTriggerStore } from "@utils/createTriggerStore";

export type ToastSeverity = "success" | "error" | "info" | "warning";

export interface ToastPayload {
  severity: ToastSeverity;
  message: string;
  duration?: number;
}

const store = createTriggerStore<ToastPayload>();

export const openToast = store.open;
export const closeToast = store.close;
export const useToastTrigger = store.useTrigger;
